import { USER_PROFILE_KEYS } from "../types";

export const firstStepFields = [
  "name",
  "email",
  "phone",
  "identification_type",
  "identification_number",
];

export const secondStepFields = [
  "business_name",
  "identification_type",
  "identification_number",
  "address_line",
];

export const thirdStepFields = ["mercado_pago", "terms_and_conditions"];

export const TITLES = [
  "Datos Personales",
  "Datos de Comercio",
  "Solicitud de Alta",
];

export const STEPS = 3;

/**
 * Map of user profile keys sorted by step.
 */
export const USER_PROFILE_KEY_BY_STEP = [
  USER_PROFILE_KEYS.GENERAL_PROFILE,
  USER_PROFILE_KEYS.BUSINESS_PROFILE,
];

export const PERSONAL_IDENTIFICATION_TYPES = [
  {
    label: "DNI",
    value: "0",
  },
  {
    label: "Pasaporte",
    value: "1",
  },
];

export const BUSINESS_IDENTIFICATION_TYPES = [
  {
    label: "CUIT",
    value: "0",
  },
  {
    label: "CUIL",
    value: "1",
  },
];
